var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0102 10.6565C19.0102 16.1091 11.9997 20.7827 11.9997 20.7827C11.9997 20.7827 4.98926 16.1091 4.98926 10.6565C4.98926 8.79718 5.72786 7.01404 7.04258 5.69932C8.3573 4.3846 10.1404 3.646 11.9997 3.646C13.859 3.646 15.6422 4.3846 16.9569 5.69932C18.2716 7.01404 19.0102 8.79718 19.0102 10.6565Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12.9935C13.2905 12.9935 14.3367 11.9472 14.3367 10.6566C14.3367 9.36606 13.2905 8.31982 11.9999 8.31982C10.7093 8.31982 9.66309 9.36606 9.66309 10.6566C9.66309 11.9472 10.7093 12.9935 11.9999 12.9935Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMapPin);
export default __webpack_public_path__ + "static/media/FooterMapPin.a14f26c35683ed5c68b0bb4fc31ef0a2.svg";
export { ForwardRef as ReactComponent };